import { render, staticRenderFns } from "./shareholder.vue?vue&type=template&id=30c7dee4&scoped=true&"
import script from "./shareholder.vue?vue&type=script&lang=js&"
export * from "./shareholder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30c7dee4",
  null
  
)

export default component.exports